import CameraIndoorIcon from '@mui/icons-material/CameraIndoor';
import VideoCallIcon from '@mui/icons-material/VideoCall';
import {
  StepProps,
} from '@mui/material';
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import StepTemplate from 'FRONTEND/components/Calendar/AppointmentForm/StepTemplate';
import TeleconsultationImage from 'FRONTEND/components/Calendar/AppointmentPreview/teleconsultation.png';
import { TilePicker, ButtonItem } from 'FRONTEND/components/TilePicker/TilePicker';
import { pickBooth } from 'FRONTEND/reducers/bookingSlice';
import { RootState } from 'FRONTEND/reducers/types';
import { BOOTH_TOGGLE_OPTIONS } from 'FRONTEND/utils/constants';
import i18n from 'FRONTEND/utils/i18n';


type BoothValue = boolean | null;


interface BoothToggleStepProps extends Omit<StepProps, 'children'> {
  isCompleted?: boolean;
  isLocked?: boolean;
  onStepClick?: () => void;
  shouldReset?: boolean;
  onStepCompleted?: () => void;
}


export const BoothToggleStep = ({
  isCompleted,
  isLocked = false,
  onStepClick = () => {},
  shouldReset = false,
  onStepCompleted = () => {},
  ...otherProps
}: BoothToggleStepProps) => {
  const dispatch = useDispatch();
  const isBooth = useSelector((state: RootState) => state.booking.isBooth) as BoothValue;
  const isSmall = useSelector((state: RootState) => state.app.isSmall) as boolean;

  useEffect(() => {
    if (shouldReset) {
      dispatch(pickBooth({ isBooth: null }));
    }
  }, [shouldReset, dispatch]);

  const handleBoothChange = (boothValue: boolean): void => {
    dispatch(pickBooth({ isBooth: boothValue }));
    onStepCompleted();
  };

  const buttonList = useMemo((): ButtonItem<BoothValue>[] => {
    return BOOTH_TOGGLE_OPTIONS.map((option) => ({
      value: option.value,
      label: option.value ? i18n._('Booth Teleconsultation') : i18n._('Teleconsultation'),
      icon: option.value ? <CameraIndoorIcon /> : <VideoCallIcon />,
      backgroundImage: TeleconsultationImage,
    }));
  }, []);

  return (
    <StepTemplate
      label={i18n._('Choose teleconsultation mode')}
      isLocked={isLocked}
      onEditClick={() => onStepClick()}
      isStepCompleted={isCompleted}
      editText={isBooth !== null ? (isBooth ? i18n._('Booth Teleconsultation') : i18n._('Teleconsultation')) : ''}
      tooltipText={i18n._('This teleconsultation mode is required for the selected practitioner')}
      {...otherProps}
    >
      <TilePicker
        buttonList={buttonList}
        selectedValue={isBooth}
        onChange={handleBoothChange}
        isVertical={isSmall}
        emptyMessage={i18n._('No teleconsultation modes available.')}
        className='appointmentForm-input'
      />
    </StepTemplate>
  );
};
